import { Box, SimpleGrid } from '@chakra-ui/react';
import { useMemo } from 'react';
import { Column } from 'react-table';
import { DateTime } from 'luxon';
import TableComponent from 'components/TableComponent';
import { maskCurrency } from 'utils/number';
import { findReceivedFees } from 'services/api.service';
import { TypeRender } from './balances';

export default function FeesSummary() {
  const columns = useMemo(
    () =>
      [
        {
          Header: 'Origem',
          accessor: 'originName',
          Cell: ({ value }: any) => value || '---',
        },
        {
          Header: 'Tipo',
          accessor: 'type',
          Cell: ({ value, row }: any) => TypeRender(value, row.original.amount),
        },
        {
          Header: 'Valor',
          accessor: 'amount',
          Cell: ({ value }: any) => maskCurrency(value),
        },
        {
          Header: 'Descrição',
          accessor: 'description',
          Cell: ({ value }: any) => value || '---',
        },
        {
          accessor: 'createdAt',
          Header: 'Data',
          Cell: ({ value }: any) =>
            value ? DateTime.fromISO(value).toFormat('dd/MM/yyyy HH:mm:ss') : '---',
        },
      ] as Column[],
    [],
  );

  const actions = () => null;

  return (
    <Box>
      <SimpleGrid mb="20px" columns={{ sm: 1 }} spacing={{ base: '20px', xl: '20px' }}>
        <TableComponent
          label="Resumo de taxas"
          columnsData={columns}
          filterable={['createdAt']}
          right={<></>}
          queryFn={findReceivedFees}
          queryKey="findReceivedFees"
          actions={actions}
          feesSummary
        />
      </SimpleGrid>
    </Box>
  );
}
